import {useUnreadMessages} from "./utils";
import React from "react";
import {directMessageSetReceiverTagOwner} from "../../exhibition_actions";
import {useDispatch} from "react-redux";
import ChatMessageTagOwnerImage from "./chat_message_tag_owner_image";



const UnreadMessageBadge = ({unreadMessages}) => {
  if (unreadMessages == 0) {
    return null
  }
  return <span className="badge badge-pill badge-colored">
      {unreadMessages}
    </span>;
}

export const ChatPreview = ({chat, setSearchResults, onlineState}) => {
  const dispatch = useDispatch()
  const unreadMessages = useUnreadMessages(chat.tagOwner.id)

  console.log("chat preview tag owner", chat.tagOwner)

  return <div key={chat.tagOwner.id} className="row" onClick={() => {
    setSearchResults(null)
    dispatch(directMessageSetReceiverTagOwner(chat.tagOwner))
  }}>
    <div className="col-12">
      <div className="chat-preview">
        <strong className={chat.tagOwner.moderator ? "moderator" : ""}>
          <ChatMessageTagOwnerImage onlineState={onlineState} tagOwner={chat.tagOwner} />

          {" " + chat.tagOwner.name + " "}
          {/*<UnreadMessageBadge unreadMessages={unreadMessages.length}/>*/}
          {/*{unreadMessages.length > 0 ? (" (" + unreadMessages.length + ") ") : ""}*/}
        </strong>

        {chat.tagOwner.company && <>
          <br/>
          {chat.tagOwner.company}
        </>}

        {chat.tagOwner.position && <>
          <br/>
          {chat.tagOwner.position}
        </>}
        <hr style={{margin: "0.5rem"}}/>
        <p>
          {chat.messages[0]?.body}
        </p>
        <div className="text-center">
          {unreadMessages.length > 0 && <span className="badge badge-pill badge-colored">
            {unreadMessages.length}
            {" "}
            unread messages
          </span>}
        </div>
      </div>
    </div>
  </div>
}